/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Heading_1Inputs */

const et_about_heading_1 = /** @type {(inputs: About_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehitatud kogemuse pealt.`)
};

const en_about_heading_1 = /** @type {(inputs: About_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built from real experience.`)
};

/**
* | output |
* | --- |
* | "Built from real experience." |
*
* @param {About_Heading_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const about_heading_1 = /** @type {((inputs?: About_Heading_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Heading_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_about_heading_1(inputs)
	return en_about_heading_1(inputs)
});